<template>
    <div>
        <swb-query-sort-area ref="query_model" :config="queryConfig" :queryKey="queryKey" :queryHandler="queryHandler"></swb-query-sort-area>
        <div class="simple-row">
            <div class="left">
                <button class="swb-btn swb-btn-small" @click="addRootCat()" v-if="checkActionPerm('create')">
                    <span>一级分类添加</span>
                </button>
            </div>
            <div class="right">
                <a class="swb-btn swb-btn-small swb-btn-primary" v-if="checkActionPerm('applyGoodsCat')" @click="doApplyDevcCatBatch">批量申请商品分类</a>
                <a class="swb-btn swb-btn-small swb-btn-primary" v-if="checkActionPerm('import')" @click="generalImport">资产分类导入</a>
            </div>
        </div>
        <div class="table-tree col6">
            <div class="tree-tit">
                <div class="td1 fl font-bold">内部分类名称</div>
                <div class="td2 fl font-bold">内部分类编码</div>
                <div class="td3 fl font-bold">状态</div>
                <div class="td4 fl font-bold">新增子分类</div>
                <div class="td5 blue fl font-bold">排序</div>
                <div class="td6 fl font-bold">操作</div>
            </div>
            <ul class="tree-list">
                <li class="first-tree" v-for="firstLevel in devcCatList">
                    <div class="first-tree-tit">
                        <div class="td1 fl align-left" @click="showDevcCatSons(firstLevel.id)">
                                <span v-if="firstLevel.devcCatSons != null && firstLevel.devcCatSons.length > 0">
                                    <i v-if="selectDevcCatIds.indexOf(firstLevel.id) > -1" class="icon iconfont icon-down"></i>
                                    <i v-else="" class="icon iconfont icon-right"></i>
                                </span>
                            <span>{{firstLevel.name}}</span>
                        </div>
                        <div class="td2 fl align-left">
                            <span>{{firstLevel.code}}</span>
                        </div>
                        <div class="td3 fl align-center">
                            <span v-if="firstLevel.applyState == 0">未申请</span>
                            <span v-if="firstLevel.applyState == 1" class="font-green">已申请</span>
                            <span v-if="firstLevel.auditState == 1" class="font-green">审核已通过</span>
                            <span v-if="firstLevel.auditState == -1" class="font-red">审核未通过</span>
                        </div>
                        <div class="td4 font-blue fl align-center">
                            <i class="icon iconfont icon-jiahao" v-if="checkActionPerm('create')"></i>
                            <a class="swb-btn swb-btn-link" v-if="checkActionPerm('create')" @click="addChildrenCat(firstLevel)">新增二级分类</a>
                        </div>
                        <div class="td5 font-blue fl align-center">
                            <i class="icon iconfont icon-arrow-top" @click="movetoUp(firstLevel)"></i>
                            <i class="icon iconfont icon-arrow-bottom" @click="movetoDown(firstLevel)"></i>
                        </div>
                        <div class="td6 fl align-left">
                            <a class="swb-btn swb-btn-link" v-if="checkActionPerm('delete') && firstLevel.retailerId == currentRetailerId" @click="deleteCat(firstLevel.id)">删除</a>
                            <a class="swb-btn swb-btn-link" v-if="checkActionPerm('edit') && firstLevel.retailerId == currentRetailerId" @click="editCat(firstLevel)">编辑</a>
                            <a class="swb-btn swb-btn-link" v-if="checkActionPerm('show')" @click="showCat(firstLevel.id)">查看</a>
                            <a class="swb-btn swb-btn-link" v-if="checkActionPerm('syncData')" @click="syncData(firstLevel.id, true)">同步关联数据</a>
                        </div>
                    </div>
                    <template v-if="selectDevcCatIds.indexOf(firstLevel.id) > -1 && firstLevel.devcCatSons != null && firstLevel.devcCatSons.length > 0">
                        <ul class="second-tree-list" v-for="secondLevel in firstLevel.devcCatSons">
                            <li class="second-tree">
                                <div class="second-tree-tit">
                                    <div class="td1 fl align-left" @click="showDevcCatSons(secondLevel.id)">
                                            <span v-if="secondLevel.devcCatSons != null && secondLevel.devcCatSons.length > 0">
                                                <i v-if="selectDevcCatIds.indexOf(secondLevel.id) > -1" class="icon iconfont icon-down"></i>
                                                <i v-else="" class="icon iconfont icon-right"></i>
                                            </span>
                                        <span>{{secondLevel.name}}</span>
                                    </div>
                                    <div class="td2 fl align-left">
                                        <span>{{secondLevel.code}}</span>
                                    </div>
                                    <div class="td3 fl align-center">
                                        <span v-if="secondLevel.applyState == 0">未申请</span>
                                        <span v-if="secondLevel.applyState == 1" class="font-green">已申请</span>
                                        <span v-if="secondLevel.auditState == 1" class="font-green">审核已通过</span>
                                        <span v-if="secondLevel.auditState == -1" class="font-red">审核未通过</span>
                                    </div>
                                    <div class="td4 font-blue fl align-center">
                                        <i class="icon iconfont icon-jiahao" v-if="checkActionPerm('create')"></i>
                                        <a class="swb-btn swb-btn-link" v-if="checkActionPerm('create')" @click="addChildrenCat(secondLevel)">新增三级分类</a>
                                    </div>
                                    <div class="td5 font-blue fl align-center">
                                        <i class="icon iconfont icon-arrow-top" @click="movetoUp(secondLevel)"></i>
                                        <i class="icon iconfont icon-arrow-bottom" @click="movetoDown(secondLevel)"></i>
                                    </div>
                                    <div class="td6 fl align-left">
                                        <a class="swb-btn swb-btn-link" v-if="checkActionPerm('delete') && secondLevel.retailerId == currentRetailerId" @click="deleteCat(secondLevel.id)">删除</a>
                                        <a class="swb-btn swb-btn-link" v-if="checkActionPerm('edit') && secondLevel.retailerId == currentRetailerId" @click="editCat(secondLevel)">编辑</a>
                                        <a class="swb-btn swb-btn-link" v-if="checkActionPerm('show')" @click="showCat(secondLevel.id)">查看</a>
                                        <a class="swb-btn swb-btn-link" v-if="checkActionPerm('syncData')" @click="syncData(secondLevel.id, true)">同步关联数据</a>
                                    </div>
                                </div>
                                <div v-if="selectDevcCatIds.indexOf(secondLevel.id) > -1 && secondLevel.devcCatSons != null && secondLevel.devcCatSons.length > 0">
                                    <ul class="third-tree-list" v-for="thirdLevel in secondLevel.devcCatSons">
                                        <li class="third-tree">
                                            <div class="third-tree-tit">
                                                <div class="td1 fl align-left">
                                                    <span>{{thirdLevel.name}}</span>
                                                </div>
                                                <div class="td2 fl align-left">
                                                    <span>{{thirdLevel.code}}</span>
                                                </div>
                                                <div class="td3 fl align-center">
                                                    <span v-if="thirdLevel.applyState == 0">未申请</span>
                                                    <span v-else-if="thirdLevel.applyState == 1" class="font-green">已申请</span>
                                                    <span v-else-if="thirdLevel.auditState == 1" class="font-green">审核已通过</span>
                                                    <span v-else-if="thirdLevel.auditState == -1" class="font-red">审核未通过</span>
                                                </div>
                                                <div class="td4 font-blue fl align-center">
                                                    &nbsp;<!--新增-->
                                                </div>
                                                <div class="td5 font-blue fl align-center">
                                                    <i class="icon iconfont icon-arrow-top" @click="movetoUp(thirdLevel)"></i>
                                                    <i class="icon iconfont icon-arrow-bottom" @click="movetoDown(thirdLevel)"></i>
                                                </div>
                                                <div class="td6 fl align-left">
                                                    <!-- 非申请中均可删除 -->
                                                    <a class="swb-btn swb-btn-link" v-if="checkActionPerm('delete') && thirdLevel.applyState != 1 && thirdLevel.retailerId == currentRetailerId" @click="deleteCat(thirdLevel.id)">删除</a>
                                                    <a class="swb-btn swb-btn-link"
                                                       v-if="checkActionPerm('edit') && (!needAudit || thirdLevel.applyState != 1 && thirdLevel.auditState != 1 && thirdLevel.retailerId == currentRetailerId)"
                                                       @click="editCat(thirdLevel)">编辑</a>

                                                    <a class="swb-btn swb-btn-link" v-if="checkActionPerm('apply') && thirdLevel.applyState != 1 && thirdLevel.auditState != 1 && thirdLevel.retailerId == currentRetailerId"
                                                       @click="applyDevcCat(thirdLevel)">申请</a>
                                                    <a class="swb-btn swb-btn-link" v-if="checkActionPerm('audit') && thirdLevel.applyState == 1 && thirdLevel.auditorPostId == currentPostId && thirdLevel.retailerId == currentRetailerId"
                                                       @click="auditDevcCat(thirdLevel)">审核</a>

                                                    <a class="swb-btn swb-btn-link" v-if="checkActionPerm('show')" @click="showCat(thirdLevel.id)">查看</a>
                                                    <span v-if="thirdLevel.auditState == 1">
                                                        <a class="swb-btn swb-btn-link" v-if="checkActionPerm('disabled') && !thirdLevel.disabled && thirdLevel.retailerId == currentRetailerId"
                                                           @click="disabledCat(thirdLevel.id, true)">禁用</a>
                                                        <a class="swb-btn swb-btn-link" v-if="checkActionPerm('enable') && thirdLevel.disabled && thirdLevel.retailerId == currentRetailerId"
                                                           @click="disabledCat(thirdLevel.id,false)">启用</a>
                                                        <a class="swb-btn swb-btn-link" v-if="checkActionPerm('setGoodsCat')" @click="setGoodsCat(thirdLevel.id)">关联商品分类</a>
                                                        <a class="swb-btn swb-btn-link" v-if="checkActionPerm('applyGoodsCat')" @click="doApplyDevcGoodsCat(thirdLevel, firstLevel, secondLevel)">申请商品分类</a>
                                                        <a class="swb-btn swb-btn-link" v-if="checkActionPerm('showApplyRec')" @click="showApplyRec(thirdLevel.id)">查看申请记录</a>
                                                        <a class="swb-btn swb-btn-link" v-if="checkActionPerm('syncData') && thirdLevel.applyState != 0" @click="syncData(thirdLevel.id, true)">同步关联数据</a>
                                                    </span>
                                                    <a class="swb-btn swb-btn-link" v-if="checkActionPerm('auditRec')" @click="getDevcCatAuditRecList(thirdLevel.id)">审核记录</a>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </template>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import {Utils, $} from '../../app.base'
    import {Vue, MsgBox, Routes, DomSizeWatcher, filterByNameExt} from '../../app.vues'
    import {openDevcCatSaveDlg, openDevcCatImpCheckDlg, openDevcCatDetailDlg, openDevcCatApplyRecListDlg} from './selectDlg'
    import {openAssetKindListSelectDlg} from './selectDlg'
    import {fileUploadGroupShowDlg} from '../comn/dialog'
    import {showComActionPostSelectDlg} from '../merchant/showSelectDlg'
    import {openAssetVoucherAuditDlg} from '../scrapVoucher/selectDlg'
    import {openAuditDlg} from '../bizUnion/selectDlg';
    import {getMerchantBizParam} from '../asset/assetMain'
    import {checkUserActionPerm} from '../index'

    import userApi from '../../api/user'
    import shopDevcApi from '../../api/shopDevc'
    import devcDefApi from '../../api/devcDef'

    import SwbCategTree from '../categ/CategTree';
    Vue.regist(SwbCategTree);
    import SwbFileItem from '../ctrl/FileItem';
    Vue.regist(SwbFileItem);
    import SwbFileUpload from '../ctrl/FileUpload';
    Vue.regist(SwbFileUpload);

    import SwbDevcGoodsCatRelList from './DevcGoodsCatRelList';
    Vue.regist(SwbDevcGoodsCatRelList);

    import AssetKindSync from './AssetKindSync';
    Vue.regist(AssetKindSync);

    import SwbDevcCatAuditRecList from './DevcCatAuditRecList';
    Vue.regist(SwbDevcCatAuditRecList);

    let searchConfigData = {
        "queryFields": [{
            "type": "Text",
            "label": "内部分类名称",
            "code": "name",
            "valueType": "String",
            "basic": true
        }, {
            "type": "Text",
            "label": "内部分类编码",
            "code": "code",
            "basic": true,
            "valueType": "String"
        }, {
            "type": "Select",
            "label": "状态",
            "code": "state",
            "basic": true,
            "dataList": [{
                "value": null,
                "label": "- 全部 -"
            }, {
                "value": "0",
                "label": "未申请"
            }, {
                "value": "1",
                "label": "已申请"
            }, {
                "value": "2",
                "label": "审核已通过"
            }, {
                "value": "3",
                "label": "审核未通过"
            }],
            "valueType": "Integer"
        }],
        "sortFields": []
    };

    export default {
        name: 'swb-devc-cat-list',
        path: '/devc/cat/list',
        desc: '自有资产分类列表',
        data: function () {
            return {
                devcCatList: [],
                selectDevcCatIds: [],
                searchContent: null,
                catList: [],// 原数据存放
                //
                queryConfig: null,
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                currentPostId: null,
                currentRetailerId: null,
                //
                needAudit: false
            }
        },
        created(){
            this.queryConfig = searchConfigData || {};
            let self = this;
            userApi.getUserInfoByContext({}, function (result, jqXhr) {
                self.currentPostId = result.data.scopeEntity.postId;
                self.currentRetailerId = result.data.scopeEntity.id;
            });
            getMerchantBizParam("asset.category.create.alter.need.audit", function (result) { // 显示门店/机构的仓库： {}
                self.needAudit = Utils.isTrue(result);
            }, 0);
            //
            this.getDevcCatList();
        },
        methods: {
            checkActionPerm: function (action) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, null);
            },
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                let filterItems = queryModel.filterItems;
                let searchValueMap = {};
                let columnNames = [];
                let name = filterItems.name;
                if (!Utils.isNoB(name)) {
                    searchValueMap['name'] = name;
                    columnNames.push('name');
                }
                let code = filterItems.code;
                if (!Utils.isNoB(code)) {
                    searchValueMap['code'] = code;
                    columnNames.push('code');
                }
                let state = filterItems.state;
                if (!Utils.isNoB(state)) {
                    if (state == 0) {
                        searchValueMap['applyState'] = '0';
                        columnNames.push('applyState');
                    } else if (state == 1) {
                        searchValueMap['applyState'] = '1';
                        columnNames.push('applyState');
                    } else if (state == 2) {
                        searchValueMap['auditState'] = '1';
                        columnNames.push('auditState');
                    } else if (state == 3) {
                        searchValueMap['auditState'] = '-1';
                        columnNames.push('auditState');
                    }
                }
                this.searchCat(columnNames.length > 0, columnNames.length > 0 ? searchValueMap : null, columnNames);
            },
            searchCat: function (spread, searchValueMap, columnNames) {
                let devcCatList = this.catList;
                let selectDevcCatIds = this.selectDevcCatIds = [];
                if (columnNames.length > 0) {
                    let catList = Utils.merge([], this.catList);
                    let nodeKey = [];
                    devcCatList = filterByNameExt(catList, searchValueMap, "devcCatSons", false, nodeKey, "id", columnNames);
                    //
                    if (spread && devcCatList != null && devcCatList.length > 0) {
                        devcCatList.forEach(function (firstLevel) {
                            selectDevcCatIds.push(firstLevel.id);
                            if (firstLevel.devcCatSons != null && firstLevel.devcCatSons.length > 0) {
                                firstLevel.devcCatSons.forEach(function (secondLevel) {
                                    selectDevcCatIds.push(secondLevel.id);
                                });
                            }
                        });
                        this.selectDevcCatIds = selectDevcCatIds;
                    }
                }
                this.devcCatList = Utils.merge([], devcCatList);
            },
            //获取商品分类树列表
            getDevcCatList(){
                let self = this;
                let postData = {};
                let theLoad = MsgBox.loading();
                shopDevcApi.getDevcCatTreeList(postData, function (result) {
                    theLoad.hide();
                    if (result.type == 'info') {
                        //
                        let catList = result.data || [];
                        self.devcCatrelation(catList)
                        self.searchCat(false, null, []);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            devcCatrelation(catList){
                let self = this;
                catList.forEach(function (item) {
                    let catSons = item.devcCatSons || [];
                    if (catSons.length > 0) {
                        self.devcCatrelation(catSons);
                    } else {
                        if (item.level == 3) {
                            if (!Utils.isNoB(item.goodsCatId)) {
                                item.catrelation = "true";
                            } else {
                                item.catrelation = "false";
                            }
                        }
                    }
                });
                self.catList = catList;
            },

            //展示商品分类子项
            showDevcCatSons: function (id) {
                let selectDevcCatIds = this.selectDevcCatIds;
                if (selectDevcCatIds.indexOf(id) > -1) {
                    this.selectDevcCatIds.remove(id);
                } else {
                    this.selectDevcCatIds.push(id);
                }
            },
            //添加商品分类
            addRootCat: function () {
                this.showDlg({});
            },
            //新增分类子项
            addChildrenCat: function (item) {
                let parms = {};
                let devcCatSons = item.devcCatSons || [];
                let seqNo = devcCatSons.length;
                if (seqNo < 10) {
                    seqNo = "00" + (seqNo + 1);
                } else if (99 < seqNo >= 10) {
                    seqNo = "0" + (seqNo + 1);
                } else if (seqNo >= 100) {
                    seqNo = seqNo + 1;
                }
                parms.level = item.level + 1;
                parms.parentId = item.id;
                parms.name = item.name;
                parms.code = item.code + seqNo;
                parms.fiscalAcctAutoIn = item.fiscalAcctAutoIn;
                parms.durableLife = item.durableLife;
                parms.vendorUknoFlag = item.vendorUknoFlag;
                parms.deprOn1stMonth = item.deprOn1stMonth;
                this.showDlg(parms);
            },
            //编辑分类
            editCat: function (item) {
                let parms = {};
                parms.level = item.level;
                parms.id = item.id;
                this.showDlg(parms, item);
            },
            showDlg: function (parms, item) {
                let self = this;
                parms.enableApply = this.checkActionPerm('apply') && this.needAudit && Utils.isNoB(item);
                //
                openDevcCatSaveDlg(parms, function (theResult, applyFlag) {
                    theResult.parentId = parms.parentId;
                    theResult.level = parms.level;
                    //
                    if (applyFlag) {
                        let params = {
                            bizName: "DevcCatAuditInfo"
                        };
                        let theLoad = MsgBox.loading();
                        devcDefApi.getDevcDefLastAuditInfo(params, function (resultX) {
                            theLoad.hide();
                            if (resultX.type == 'info') {
                                showComActionPostSelectDlg({
                                    title: '指定审核岗',
                                    rescUrl: Vue.$getClassInfo(self).path,
                                    action: "audit",
                                    useParents: true,
                                    initPostId: Utils.isNoB(resultX.data) ? null : resultX.data.postId || null,
                                    useDesc: true,
                                    applyDesc: Utils.isNoB(item) ? "" : item.applyDesc
                                }, function (resultData) {
                                    resultData = resultData || {};
                                    if (resultData.postId == null) {
                                        Toast.show('请选择审核岗位', 3000, 'warning');
                                        return false;
                                    }
                                    theResult.auditorPostId = resultData.postId;
                                    theResult.auditorPostName = resultData.postName;
                                    theResult.applyDesc = resultData.applyDesc;
                                    theResult.autoApply = true;
                                    self.saveDevcCatFunc(theResult, item);
                                }, this);
                            } else {
                                MsgBox.warning(resultX.message);
                            }
                        });
                    } else {
                        self.saveDevcCatFunc(theResult, item);
                    }
                });
            },
            saveDevcCatFunc: function (theResult, item) {
                let self = this;
                let theLoad = MsgBox.loading();
                shopDevcApi.saveDevcCat(theResult, function (result) {
                    theLoad.hide();
                    if (result.type === "info") {
                        if (item != null) {
                            if (theResult.fiscalAcctAutoIn != item.fiscalAcctAutoIn ||
                                theResult.durableLife != item.durableLife ||
                                theResult.vendorUknoFlag != item.vendorUknoFlag
                            ) {
                                self.syncData(item.id, false);
                            } else {
                                MsgBox.success("操作成功");
                            }
                        }
                        self.getDevcCatList();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 申请
            applyDevcCat: function (thirdLevel) {
                let self = this;
                let params = {
                    bizName: "DevcCatAuditInfo"
                };
                let theLoad = MsgBox.loading();
                devcDefApi.getDevcDefLastAuditInfo(params, function (resultX) {
                    theLoad.hide();
                    if (resultX.type == 'info') {
                        showComActionPostSelectDlg({
                            title: '指定审核岗',
                            rescUrl: Vue.$getClassInfo(self).path,
                            action: "audit",
                            useParents: true,
                            initPostId: Utils.isNoB(resultX.data) ? null : resultX.data.postId || null,
                            useDesc: true,
                            applyDesc: thirdLevel.applyDesc
                        }, function (resultData) {
                            resultData = resultData || {};
                            if (resultData.postId == null) {
                                Toast.show('请选择审核岗位', 3000, 'warning');
                                return false;
                            }
                            let postData = {
                                id: thirdLevel.id,
                                auditorPostId: resultData.postId,
                                auditorPostName: resultData.postName,
                                applyDesc: resultData.applyDesc,
                            };
                            let theLoad = MsgBox.loading();
                            shopDevcApi.applyDevcCatInfo(postData, function (result) {
                                theLoad.hide();
                                if (result.type == 'info') {
                                    MsgBox.success('申请成功！');
                                    //
                                    self.getDevcCatList();
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            });
                        }, this);
                    } else {
                        MsgBox.warning(resultX.message);
                    }
                });
            },
            // 审核
            auditDevcCat: function (thirdLevel) {
                let self = this;
                openAuditDlg(thirdLevel, function (result) {
                    let postData = {
                        id: thirdLevel.id,
                        auditState: result.resource,
                        auditDesc: result.desc,
                    };
                    let theLoad = MsgBox.loading();
                    shopDevcApi.aduitDevcCatInfo(postData, function (result) {
                        theLoad.hide();
                        if (result.type == 'info') {
                            MsgBox.success('操作成功！');
                            //
                            self.getDevcCatList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                });
            },

            //删除分类
            deleteCat: function (id) {
                let self = this;
                self.$confirm('确定要删除该自有资产分类?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    //判断是否符合删除条件
                    let theLoad = MsgBox.loading();
                    shopDevcApi.getDevcCatListByParentId(id, function (result) {
                        if (result.type === "info") {
                            self.getDevcCatRel(id, function (relMap) {
                                if (relMap.zcdy > 0 || relMap.devc > 0) {
                                    theLoad.hide();
                                    MsgBox.warning('存在关联数据,不可删除,可操作【同步关联数据】进行查看');
                                } else {
                                    shopDevcApi.deleteDevcCat(id, function (result) {
                                        theLoad.hide();
                                        if (result.type == 'info') {
                                            MsgBox.success("删除成功");
                                            self.getDevcCatList();
                                        } else {
                                            MsgBox.warning(result.message);
                                        }
                                    });
                                }
                            });
                        } else {
                            MsgBox.warning(result.message);
                            theLoad.hide();
                        }
                    });
                });
            },
            move(postData){
                let self = this;
                let theLoad = MsgBox.loading();
                shopDevcApi.moveDevcCatSeq(postData, function (result) {
                    theLoad.hide();
                    if (result.type == 'info') {
                        self.getDevcCatList();
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            movetoUp(item){
                let postData = {};
                postData.id = item.id;
                postData.toUp = true;
                this.move(postData);
            },
            movetoDown(item){
                let postData = {};
                postData.id = item.id;
                postData.toUp = false;
                this.move(postData);
            },
            setGoodsCat: function (id) {
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: '关联商品分类',
                    okVisible: false,
                    showCloseBtn: true,
                    cancelText: "关闭",
                    width: 1000,
                    height: 800,
                    template: '<swb-devc-goods-cat-rel-list :devcCatId="devcCatId" ref="swb_devc_goods_cat_rel_list"></swb-devc-goods-cat-rel-list>',
                    data: {
                        devcCatId: id
                    },
                    methods: {},
                    okClicked: function () {
                        let result = this.$refs.swb_devc_goods_cat_rel_list.getDlgResult() || {};
                        if (result.type == 'info') {
                            let postData = {};
                        } else {
                            this.$message.error(result.message);
                        }
                        return false;
                    }
                });
            },
            setGoodsCat1: function (id) {
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: '商品分类信息',
                    showCloseBtn: true,
                    template: '<div>' +
                    '<swb-categ-tree :noPostFilters="true" :isClickEvent="false" :enableSearch = "enableSearch" ref="swb_categ_tree"></swb-categ-tree>' +
                    '</div>',
                    data: {
                        enableSearch: true
                    },
                    methods: {
                        updateDevcCatGoodsCatById: function (postData) {
                            let loading = MsgBox.loading();
                            shopDevcApi.updateDevcCatGoodsCatById(postData, function (result) {
                                loading.close();
                                if (result.type == "info") {
                                    theDlg.close();
                                    MsgBox.success("关联成功");
                                    self.getDevcCatList();
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            })
                        }
                    },
                    okClicked: function () {
                        let result = this.$refs.swb_categ_tree.getDlgResult() || {};
                        if (result != null && result.type === 'info') {
                            let postData = {};
                            let categ = result.data;
                            postData.goodsCatId = categ.id;
                            postData.id = id;
                            this.updateDevcCatGoodsCatById(postData);
                        } else {
                            this.$message.error(result.message);
                        }
                        return false;
                    },
                    lifecycle: {
                        created: function () {
                        }
                    }
                });
            },
            disabledCat: function (id, disabled) {
                let self = this;
                self.$confirm('确定要禁用该自有资产分类?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    //判断是否符合删除条件
                    let theLoad = MsgBox.loading();
                    let postData = {
                        id: id,
                        disabled: disabled
                    }
                    shopDevcApi.updateDevcCatDisabledById(postData, function (result) {
                        theLoad.hide();
                        if (result.type == 'info') {
                            self.getDevcCatList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                });
            },
            downloadTemplate: function () {
                let url = "/api/shop/devc/cat/imp/model/template/file/download";
                Utils.setPageUrl(getAppUrl(url), '_blank');
            },
            //上传前（进行验证检查）处理，可以返回false取消上传
            onBeforeUpload: function (fileItems, uploader) {
                if (fileItems.length === 0) {
                    this.$message.error('请选择要上传的文件');
                    return false;
                }
                this.theLoader = MsgBox.loading("正在解析文件");
            },
            //上传进度处理
            onProgress: function (progress) {
                let percentage = Math.floor((progress.loaded / progress.total) * 100);
            },
            //上传完毕处理（根据result.type判断是否有误）
            onUploadDone: function (result) {
                this.theLoader.hide();
                //
                let self = this;
                if (result.type === 'info') {
                    let files = result.data.files;
                    self.file = files[0];
                    // 文件是否按模版导入
                    let errorMsgList = self.file.extra.errorMsgList;
                    if (!Utils.isNoB(errorMsgList) && errorMsgList.length > 0) {
                        MsgBox.warning(errorMsgList.join("<br/>"));
                        return;
                    }
                    self.openShopDeviceImpCheckDlg(self.file);
                } else {
                    this.$message.warning(result.message);
                }
            },
            openShopDeviceImpCheckDlg (fileObj) {
                let self = this;
                openDevcCatImpCheckDlg(fileObj, function () {
                        // 导入后回调的方法,刷新列表
                        self.getDevcCatList();
                        MsgBox.info("执行完毕");
                    }
                );
            },
            showCat: function (id) {
                openDevcCatDetailDlg(id);
            },
            doApplyDevcGoodsCat: function (thirdLevel, firstLevel, secondLevel) {
                let title = firstLevel.name + "_" + secondLevel.name + "_" + thirdLevel.name;
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: "分类申请",
                    width: 700,
                    height: 340,
                    showCloseBtn: true,
                    template: '<div class="simple-form">' +
                    '   <div class="form-group center">' +
                    '        <div class="form-label">' +
                    '            <label>分类信息</label>' +
                    '        </div>' +
                    '        <div class="form-value">' +
                    '            <span>{{title}}</span>' +
                    '        </div>' +
                    '   </div>' +
                    '   <div class="form-group center">' +
                    '        <div class="form-label">' +
                    '            <label>申请描述</label>' +
                    '        </div>' +
                    '        <div class="form-value width-2x">' +
                    '            <label><el-input type="textarea"  placeholder="请输入描述" v-model="applyDesc"></el-input></label>' +
                    '        </div>' +
                    '   </div>' +
                    '</div>',
                    data: {
                        applyDesc: null,
                        title: title
                    },
                    okClicked: function () {
                        let postData = {};
                        postData.id = thirdLevel.id || [];
                        postData.applyDesc = this.applyDesc;
                        //
                        let theLoad = MsgBox.loading();
                        shopDevcApi.doApplyDevcCat(postData, function (result) {
                            theLoad.hide();
                            if (result.type === "info") {
                                theDlg.close();
                                self.getDevcCatList();
                                MsgBox.success("申请成功");
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                        return false;
                    }
                });
            },
            showApplyRec: function (id) {
                openDevcCatApplyRecListDlg(id);
            },
            doApplyDevcCatBatch: function () {
                let self = this;
                self.$confirm('确定要批量申请自有资产分类?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    //判断是否符合删除条件
                    let theLoad = MsgBox.loading();
                    shopDevcApi.doApplyDevcCatBatch({}, function (result) {
                        theLoad.hide();
                        if (result.type == 'info') {
                            self.getDevcCatList();
                            MsgBox.success("申请成功");
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                });
            },
            generalImport: function () {
                let self = this;
                let uploadParams = {
                    title: "资产分类导入",
                    fileGroup: "devcCat.import",
                    multipleFile: false
                };
                fileUploadGroupShowDlg(uploadParams, "/api/shop/devc/cat/imp/model/template/file/download", function (result, theDlg) {
                    // theDlg 关闭弹框
                    theDlg.close();
                    if (result.type === 'info') {
                        let files = result.data.files;
                        self.file = files[0];
                        // 文件是否按模版导入
                        let errorMsgList = self.file.extra.errorMsgList;
                        if (!Utils.isNoB(errorMsgList) && errorMsgList.length > 0) {
                            MsgBox.warning(errorMsgList.join("<br/>"));
                            return;
                        }
                        // 验证此文件中导入的内容
                        self.openShopDeviceImpCheckDlg(self.file);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getDevcCatRel(id, callback){
                let theLoad = MsgBox.loading();
                shopDevcApi.getDevcCatRel({
                    innerDevcCatId: id
                }, function (result) {
                    theLoad.hide();
                    if (result.type === "info") {
                        callback(result.data);
                    } else {
                        callback([]);
                        MsgBox.warning(result.message);
                    }
                });
            },
            syncData(id, showMsg){
                //
                let self = this;
                this.getDevcCatRel(id, function (relMap) {
                    if (relMap.zcdy > 0 || relMap.devc > 0) {
                        self.showSync(id, '资产分类 - 同步关联数据');
                    } else {
                        if (showMsg) {
                            MsgBox.info('无关联数据或没有需要同步的数据');
                        } else {
                            MsgBox.success("操作成功");
                        }
                    }
                });
            },
            showSync(id, title){
                Vue.$showDialog({
                    title: title,
                    width: 1200,
                    height: '100%',
                    showCloseBtn: true,
                    okVisible: false,
                    cancelText: '关闭',
                    template: '<div class = "">' +
                    '<swb-asset-kind-sync :type="type" :filter="filter" :updateClick="updateClick" :type="type"></swb-asset-kind-sync>' +
                    '</div>',
                    data: {
                        filter: {
                            innerDevcCatId: id,
                            useRealQuery: true
                        },
                        type: 'devcCat'
                    },
                    methods: {
                        updateClick(allSelect){
                            let postData = Utils.merge({}, allSelect);
                            postData.srcId = id;
                            console.log(postData);
                            //
                            let theLoad = MsgBox.loading();
                            shopDevcApi.doSyncDevcCatRel(postData, function (result) {
                                theLoad.hide();
                                if (result.type === "info") {
                                    MsgBox.success('操作成功');
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            });
                        }
                    }
                })
            },
            //
            getDevcCatAuditRecList: function (devcCatId) {
                let theDlg = Vue.$showDialog({
                    title: '审核记录',
                    width: 900,
                    height: 700,
                    okVisible: false,
                    showCloseBtn: true,
                    okClicked: false,
                    cancelText: '关闭',
                    template: '<swb-devc-cat-audit-rec-list :devcCatId="devcCatId" ref="swb_devc_cat_audit_rec_list"></swb-devc-cat-audit-rec-list>',
                    data: {
                        devcCatId: devcCatId
                    },
                    methods: {}
                });
            }
        }
    }
</script>





// WEBPACK FOOTER //
// src/compo/categ/DevcCatList.vue